import { DefaultOptions, MutationCache, QueryCache, QueryObserverOptions } from 'react-query';

interface QueryClientConfig {
  queryCache?: QueryCache;
  mutationCache?: MutationCache;
  defaultOptions?: DefaultOptions<any>;
}

export const serverConfig: QueryClientConfig = {};

// retry count for external API calls
export const retryCount = 2;

/**
 * Default low-traffic options
 */
const clientOptions: QueryObserverOptions<any, any, any> = {
  // 5 second delay on stale data
  staleTime: 1000 * 5,
  // Cache for 5 minutes
  cacheTime: 1000 * 60 * 5,
  // Refetch settings
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchInterval: false,
};
export const clientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: clientOptions,
  },
};

/**
 * Options for more frequently updated data
 */
export const clientOptionsRefetch: QueryObserverOptions<any, any, any> = {
  // 5 second delay on stale data
  staleTime: 1000 * 5,
  // Cache for 5 minutes
  cacheTime: 0,
  // Refetch settings
  refetchOnMount: true,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
  refetchInterval: false,
  // retry twice before counting as a failure
  retry: retryCount,
};
